import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=3c81d5e4"
import script from "./activity.js?vue&type=script&lang=js&external"
export * from "./activity.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports